export const GETTING_NOTIFICATIONS = 'GETTING_NOTIFICATIONS';
export const GOT_NOTIFICATIONS = 'GOT_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const MARK_NOTIFICATIONS_AS_READ = 'MARK_NOTIFICATIONS_AS_READ';
export const GETTING_NOTIFICATIONS_ERROR = 'MARK_NOTIFICATIONS_AS_READ';

